module.exports = __webpack_public_path__ + "static/media/zing-banner-background.46d796d4.svg";